module.exports = __webpack_public_path__ + "img/教培.d90fd58f.svg";